import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  return <section id="testimonials" className="w-full py-12 md:py-24 bg-white" data-id="element-213">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-214">
        <div className="text-center mb-12" data-id="element-215">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-216">
            What They're Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-217">
          <div className="flex flex-col p-6 bg-gradient-to-br from-sage-50 to-navy-50 rounded-xl shadow-md" data-id="element-218">
            <div className="flex mb-4" data-id="element-219">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400 fill-amber-400" data-id="element-220" />)}
            </div>
            <p className="text-gray-700 mb-6 flex-grow" data-id="element-221">
              "I went from three espressos a day to consistent energy. My
              performance at work is way sharper—and I sleep like a baby."
            </p>
            <div className="flex items-center mt-auto" data-id="element-222">
              <div className="h-10 w-10 rounded-full overflow-hidden mr-3" data-id="element-223">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Sarah profile" className="h-full w-full object-cover" data-id="element-224" />
              </div>
              <div data-id="element-225">
                <p className="font-medium" data-id="element-226">Sarah, 29</p>
                <p className="text-sm text-gray-500" data-id="element-227">UX Designer</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col p-6 bg-gradient-to-br from-sage-50 to-navy-50 rounded-xl shadow-md" data-id="element-228">
            <div className="flex mb-4" data-id="element-229">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400 fill-amber-400" data-id="element-230" />)}
            </div>
            <p className="text-gray-700 mb-6 flex-grow" data-id="element-231">
              "I used to crash by 3 PM. Now I'm still focused at 6. My team
              noticed. My results speak for themselves."
            </p>
            <div className="flex items-center mt-auto" data-id="element-232">
              <div className="h-10 w-10 rounded-full overflow-hidden mr-3" data-id="element-233">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Marcus profile" className="h-full w-full object-cover" data-id="element-234" />
              </div>
              <div data-id="element-235">
                <p className="font-medium" data-id="element-236">Marcus, 31</p>
                <p className="text-sm text-gray-500" data-id="element-237">Marketing Director</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col p-6 bg-gradient-to-br from-sage-50 to-navy-50 rounded-xl shadow-md" data-id="element-238">
            <div className="flex mb-4" data-id="element-239">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400 fill-amber-400" data-id="element-240" />)}
            </div>
            <p className="text-gray-700 mb-6 flex-grow" data-id="element-241">
              "I was skeptical. But after 5 days on FocusFlow, I felt like I had
              leveled up. Calm energy, zero crash, and my to-do list was toast
              by noon."
            </p>
            <div className="flex items-center mt-auto" data-id="element-242">
              <div className="h-10 w-10 rounded-full bg-sage-200 flex items-center justify-center mr-3" data-id="element-243">
                <span className="text-sm font-bold text-sage-600" data-id="element-244">T</span>
              </div>
              <div data-id="element-245">
                <p className="font-medium" data-id="element-246">Tina, 25</p>
                <p className="text-sm text-gray-500" data-id="element-247">Founder</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}